module.exports = __webpack_public_path__ + "static/media/settings_active.86f1fe23.svg";